import {
    Avatar,
    Button,
    Card,
    CircularProgress,
    Fab,
    Icon,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/auth";
import { useToolbarOptions } from "../context/toolbarOptions";
import { getUser, useSharedLists } from "../api/firebase";
import "./SharedListsScreen.css";

const SharedListsScreen = () => {
    const authState = useAuth();
    const sharedLists = useSharedLists();

    const { setToolbarOptions } = useToolbarOptions();

    useEffect(() => {
        setToolbarOptions({ title: "Shared Lists", items: [] });
    }, [setToolbarOptions]);

    const getComponent = () => {
        if (!authState || (authState.user && !sharedLists)) {
            return (
                <div className="sharedListsLoading">
                    <CircularProgress color="secondary" />
                </div>
            );
        } else if (authState.user && sharedLists && sharedLists.length !== 0) {
            return <SharedLists sharedLists={sharedLists} />;
        } else {
            return <Prompt authState={authState} />;
        }
    };

    return (
        <div className="sharedListsContainer">
            {getComponent()}
            <div className="createSharedListFab">
                <Link to="/sharedlists/create">
                    <Fab color="secondary">
                        <Icon>add</Icon>
                    </Fab>
                </Link>
            </div>
        </div>
    );
};

const SharedLists = (props) => {
    const { sharedLists } = props;
    return (
        <div className="sharedLists">
            {sharedLists.map((sharedList) => (
                <SharedList key={sharedList.id} sharedList={sharedList} />
            ))}
        </div>
    );
};

const SharedList = (props) => {
    const { sharedList } = props;

    const [members, setMembers] = useState([]);

    useEffect(() => {
        const loadUser = async (userId) => {
            try {
                const user = await getUser(userId);
                if (user) {
                    setMembers((m) => [...m, user]);
                }
            } catch (_e) {
                // Ignore.
            }
        };

        for (const memberId of sharedList.members) {
            loadUser(memberId);
        }
    }, [sharedList.members]);

    return (
        <Link to={`/sharedlists/${sharedList.id}`}>
            <Card className="sharedListsItem">
                <Typography variant="h6">{sharedList.name}</Typography>
                <div style={{ display: "flex" }}>
                    {members.map((member) => (
                        <MemberImg key={member.id} member={member} />
                    ))}
                </div>
            </Card>
        </Link>
    );
};

const useMemberImgStyles = makeStyles((theme) => ({
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        margin: "5px",
    },
}));

const MemberImg = (props) => {
    const { member } = props;

    const classes = useMemberImgStyles();

    return (
        <Avatar
            src={member.photoUrl}
            alt={member.name}
            className={classes.small}
        />
    );
};

const Prompt = (props) => {
    const { authState } = props;

    return (
        <div className="sharedListsPrompt">
            <Typography variant="h6">Shared Lists</Typography>
            <Typography variant="body1" align="center">
                Create Shared Lists with your friends and keep track of movies
                to watch together!
            </Typography>
            {!authState.user && (
                <Link to="/login" style={{ marginTop: "50px" }}>
                    <Button>Login</Button>
                </Link>
            )}
        </div>
    );
};

export default SharedListsScreen;
